import * as Sentry from "@sentry/react";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!SENTRY_DSN) {
    console.info("[Sentry] DSN not configured — error tracking disabled.");
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: `medicorepay-admin@${import.meta.env.VITE_APP_VERSION || "0.0.0"}`,

    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,

    enabled: import.meta.env.PROD || !!import.meta.env.VITE_SENTRY_DSN,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    ignoreErrors: [
      "top.GLOBALS",
      "chrome-extension://",
      "moz-extension://",
      "Network Error",
      "Failed to fetch",
      "Load failed",
      "AbortError",
      "ResizeObserver loop",
    ],

    beforeSend(event) {
      if (import.meta.env.DEV && !import.meta.env.VITE_SENTRY_DSN) {
        return null;
      }
      return event;
    },
  });

  console.info("[Sentry] Error tracking initialized.");
}

export function setSentryUser(user: {
  id: string;
  email?: string;
  role?: string;
}) {
  Sentry.setUser({ id: user.id, email: user.email });
  if (user.role) {
    Sentry.setTag("user_role", user.role);
  }
}

export function clearSentryUser() {
  Sentry.setUser(null);
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
